import { FC, useState } from 'react';
import { GetCarAllocationCondition } from '../../../../../types/carAllocation';
import styles from './styles.module.css';
import Input from '../../../../../components/common/Input';
import Button from '../../../../../components/common/Button';
import { keyList, useKeyAction } from '../../../../../services/useKeyAction';

type Props = {
  initConditions: GetCarAllocationCondition;
  conditions: GetCarAllocationCondition;
  onChange: (conditions: GetCarAllocationCondition) => void;
};
const Conditions: FC<Props> = ({ initConditions, conditions, onChange }) => {
  const [currentCondition, setCurrentConditions] =
    useState<GetCarAllocationCondition>(conditions);
  const clearConditions = () => {
    setCurrentConditions({ ...initConditions });
    onChange({ ...initConditions });
  };

  const onConditionEnter = useKeyAction(keyList.ENTER, () => {
    onChange(currentCondition);
  });

  return (
    <div className={styles.container} onKeyDown={onConditionEnter}>
      <div className={styles.driverName}>
        <Input
          value={currentCondition.driverName}
          onChange={(e) => {
            setCurrentConditions({
              ...conditions,
              driverName: e.target.value,
            });
          }}
          variants={['fit']}
          placeholder="ドライバー名"
        />
      </div>
      <div className={styles.buttons}>
        <div className={styles.button}>
          <Button variants={['cancel', 'contain']} onClick={clearConditions}>
            クリア
          </Button>
        </div>
        <div className={styles.button}>
          <Button
            variants={['search', 'contain', 'secondary']}
            onClick={() => onChange(currentCondition)}
          >
            検索
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Conditions;
